import {
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
  InputBase,
} from '@material-ui/core';
import styled from 'styled-components';

const HeaderRow = styled(MuiTableRow)`
  align-items: center;
  height: 40px;
`;

const HeaderCell = styled(MuiTableCell)`
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    height: 40px;
    border-right: 1px solid #f0f0f0;
    padding: 3px 20px;
`;

const TableRow = styled(MuiTableRow)`
  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

const InputCell = styled(InputBase)`
  text-overflow: ellipsis !important;
  z-index: 1201;
  height: 4em;
  padding: 2px 5px;
  border-right: 1px solid #f0f0f0;
  background: #f3f3f3;
`;

const TableCell = styled(MuiTableCell)`
  text-overflow: ellipsis !important;
  z-index: 1201;
  height: 4em;
  padding: 2px 5px;
  border-right: 1px solid #f0f0f0;
  background: #f3f3f3;
`;

const EditableTableCell = styled(MuiTableCell)<{ $isBeingEdited?: boolean; $hasBeenEdited?: boolean }>`
  text-overflow: ellipsis !important;
  overflow: hidden;
  z-index: 1201;
  height: 4em;
  background-color: ${(props) => (props.$isBeingEdited ? '#d4ebf2' : (props.$hasBeenEdited && '#bbddbb'))};
  max-width: 200px;
  padding: 2px 5px;
  border-right: 1px solid #f0f0f0;
  cursor: pointer;
`;

export default {
  HeaderRow,
  HeaderCell,
  TableCell,
  EditableTableCell,
  TableRow,
  InputCell,
};
